import { UserModel, OrgModel } from '../../store/storeModels/user.model';
import { HttpClient } from '@angular/common/http';
import { Endpoints } from '../../shared/config/endpoints';
import { Injectable } from '@angular/core';
import { GeneralService } from '../general.service';
import { ClientTaskModel } from '../../models/task.model';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

@Injectable({
  providedIn: 'root'
})
export class ClientTaskService {
  private taskapi = this.endpoint.analyticsUrl;
  private clientapi = this.endpoint.fourFourSixEndpoint;
  private user;
  private orgID;
  // task_context specifying the part of the page where task feeds are needed
  public task_context = new BehaviorSubject<any>({});

  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.orgID = info.organization.id;
      this.user = info.user;
    });
  }

  getTaskByID(id) {
    return this.http.get(`${this.taskapi}/task/${id}`);
  }

  fetchTaskList(payload) {
    const url = `${this.taskapi}/getTasks`;
    const body = {
      ...payload,
      orgID: this.orgID,
    };
    return this.http.post(url, body);
  }

  //api to be created
  getFilteredClientTasks(clientID) {
    return this.http.get(`${this.taskapi}/getTasks/client/${this.user.id}/${this.orgID}/${clientID}`);
  }

  getFilteredTasks(clientID) {
    return this.http.get(`${this.taskapi}/getFilteredTasks/${this.user.id}/${this.orgID}/${clientID}`);
  }

  markTaskAsCompleted(id) {
    const body = {
      status: 'completed'
    }
    return this.http.put(`${this.taskapi}/statusUpdate/${id}`, body);
  }

  /**
   * Update Task with  Assigned Deal nad Client
   * @param form
   */
  pushTaskToClientCategory(form: ClientTaskModel) {
    const body = {
      ...form,
      associatedClientID: form.associatedClientID,
      category: 'client',
      clientName: form.associatedClientName,
      dealName: form.taskDealName,
      id: form.id,
      taskDeal: form.taskDeal
    };
    return this.http.put(`${this.taskapi}/updateTask`, body);
  }

  getClientByOrgID() {
    return this.http.get(`${this.clientapi}/clients`);
  }

}
